<template>
  <div>
    <div v-if="isShowSticky" style="height: 130px;"></div>
    <div :class="{ 'header-body__container': isShowSticky }">
      <div
        class="header-body"
        :style="{
          boxShadow: isShowSticky
            ? '0 8px 8px -4px rgba(0, 0, 0, 0.05)'
            : 'none',
        }"
      >
        <el-row>
          <el-col :span="12">
            <div class="header-body__vc">
              <a
                :href="$origin + '/?city=145'"
                target="_self"
                class="header-body__logo"
              >
                <!-- 英文 -->
                <img
                  v-if="CookiesOne === 'en-US'"
                  src="./imgs/logo.png"
                  alt="DF"
                />
                <!-- 中文 -->
                <img
                  v-if="CookiesOne !== 'en-US'"
                  src="./imgs/logo.png"
                  alt="东方福利网"
                />
              </a>
            </div>
          </el-col>
          <el-col :span="12" class="tr">
            <div class="header-body__search">
              <div class="header-body__vc">
                <el-row class="header-body__search_row">
                  <el-col :span="5">
                    <span v-if="dropDown" class="header-body__city">
                      <span class="header-body__city_cur" style="color: #666;">
                        {{ cityName }}
                      </span>
                    </span>
                    <span
                      v-else
                      class="header-body__city"
                      @click.stop="onToggleCity"
                    >
                      <span class="header-body__city_cur">{{
                        CookiesOne === "en-US" ? cityPinyin : cityName
                      }}</span>
                      <i
                        class="header-body__city_normal"
                        :class="flag ? 'header-body__city_active' : ''"
                      ></i>
                    </span>
                  </el-col>
                  <el-col :span="16">
                    <!-- 英文版 -->
                    <input
                      v-if="CookiesOne === 'en-US'"
                      ref="searchInput"
                      class="header-body__input"
                      placeholder="Cinema ticket, drama ticket and fitness"
                      @focus="onFocus"
                      @blur="onBlur"
                      @input="onInput"
                      @click.stop
                      @keyup.enter="onSubmit($event)"
                    />
                    <!-- 中文版 -->
                    <input
                      v-if="CookiesOne !== 'en-US'"
                      ref="searchInput"
                      class="header-body__input"
                      :placeholder="TLang('电影票、话剧票、健身', 'common')"
                      @focus="onFocus"
                      @blur="onBlur"
                      @input="onInput"
                      @click.stop
                      @keyup.enter="onSubmit($event)"
                    />
                  </el-col>
                  <el-col :span="3">
                    <a
                      href="javascript:;"
                      class="header-body__btn"
                      @click.stop="onSubmit"
                    >
                      <i class="header-body__glass">{{
                        TLang("搜索", "my")
                      }}</i>
                    </a>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
        <def-city
          v-show="flag"
          :allCities="allCities"
          :hotCities="hotCities"
          top="87px"
          @onHideCity="onHideCity"
        />
        <def-search
          v-if="showSearchLayer"
          :searches="searches"
          :products="products"
          :suggestWords="suggestWords"
          :cardInfos="cardInfos"
          :count="count"
          :records="records"
          :keyword="keyword"
          :cid="cid"
          :showRecordLayer="showRecordLayer"
          @onSubmit="onSubmit"
          @updateRecord="updateRecord"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DefCity from "./DefCity";
import DefSearch from "./DefSearch";
import Cookies from "js-cookie";
import { gioClickHandle as gioHandle, getQueryString } from "../../utils";
import Toast from "@components/simpleToast";
export default {
  components: {
    DefCity,
    DefSearch,
  },
  data() {
    return {
      allCities: [],
      hotCities: [],
      cityName:
        (Cookies.get("address") &&
          JSON.parse(Cookies.get("address") || "{}").cityName) ||
        this.TLang("上海", "my"),
      cid:
        (Cookies.get("address") &&
          JSON.parse(Cookies.get("address") || "{}").cityId) ||
        "145",
      keyword: "",
      searches: [],
      products: [],
      cardInfos: [],
      suggestWords: [],
      count: 0,
      records: [],
      showCityLayer: false,
      showSearchLayer: false,
      showRecordLayer: false,
      flag: false,
      dropDown: false,
      isShowSticky: false,
      CookiesOne: Cookies.get("df_lang"),
      cityPinyin: "",
      isJump: true,
      jumpUrl: "https://www.baidu.com/",
    };
  },
  // eslint-disable-next-line no-dupe-keys
  watch: {
    $route(newVal, oldVal) {
      const arr = ["packageDetails", "OrganDetails"];
      if (oldVal.query.city && oldVal.query.city !== newVal.query.city) {
        this.getCityData();
      }

      this.dropDown = arr.includes(newVal.name);
    },
  },
  created() {
    // 获取城市数据
    this.getCityData();
    this.keyword = this.publicMethod.getQueryString("keywords").trim();
    this.$bus.$on("onSticky", (flag) => {
      this.isShowSticky = flag;
    });
  },
  mounted() {
    document.addEventListener("click", this.onHideCity);
    this.$bus.$on("changeCity", this.onToggleCity);

    this.$nextTick(() => {
      this.$refs.searchInput.value = this.keyword;
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onHideCity);
    this.$bus.$off("changeCity", this.onToggleCity);
    this.$bus.$off("onSticky");
  },
  methods: {
    getCityData() {
      this.apis.headerApi.getCityData().then((res) => {
        this.allCities = res.cityList;
        this.hotCities = res.hotCities;
        // this.cityPinyin = res.cityPinyin;
        // this.cid = Number(res.city);
      });
    },
    onToggleCity() {
      this.flag = !this.flag;
    },
    onHideCity() {
      this.flag = false;
    },
    onFocus(ev) {
      const val = ev.target.value.trim();

      // 每次都清空收集器里的数据
      this.products = [];
      this.searches = [];
      this.cardInfos = [];
      this.count = 0;

      if (val) {
        // 保持当前值的展示状态
        this.showRecordLayer = false;
        this.getQuickSearchData(val);
        this.showSearchLayer = true;
      } else {
        // 检查cookies是否有最近搜索过的记录
        this.getSearchRecordData();
        this.showSearchLayer = this.showRecordLayer = !!this.records.length;
      }

      // 关闭城市列表
      this.onHideCity();
    },
    onBlur() {
      this.showSearchLayer = false;
    },
    onInput(ev) {
      const val = ev.target.value.trim();

      if (val) {
        this.showRecordLayer = false;
        this.getQuickSearchData(val);
        this.showSearchLayer = true;
      } else {
        this.products = [];
        this.searches = [];
        this.cardInfos = [];
        this.count = 0;

        this.getSearchRecordData();
        this.showSearchLayer = this.showRecordLayer = !!this.records.length;
      }
    },
    getSearchRecordData() {
      const searchKeywords = this.publicMethod.getCookie("searchKeywords");

      if (searchKeywords) {
        const arr = searchKeywords.split(",");
        // 如果搜索数目大于20,则选取最后20条记录
        this.records = arr.length > 20 ? arr.slice(-20) : arr;
      } else {
        this.records = [];
      }
    },
    updateRecord(val) {
      this.records = val;
    },
    setHistoryCookie(value){
      const { hostname } = window.location;
      const arr = [...this.records].filter((item) => item !== value);
      // 设置cookie
      this.publicMethod.setCookie(
        'searchKeywords',
        arr.join(','),
        604800,
        '/',
        `.${hostname}`,
      );
    },
    async onSubmit(ev, val) {
      let value = val || this.$refs.searchInput.value;
      if (value || value === 0) {
        value = value + '';
      }
      if (!value || (value && !value.trim())) {
        Toast.info('请输入搜索关键字', 3);
        return
      }
      const senRes = await this.apis.headerApi.getSensitiveUrl({ keyword: value, city: this.cid });
      if ((senRes && !senRes.body ) || !senRes){
        this.setHistoryCookie(value);
      }
      this.changeGioAndNext(value);
    },
    // 埋点和页面跳转
    changeGioAndNext(key) {
      this.apis.headerApi
        .getSearchUrl({ keyword: key, city: this.cid })
        .then((res) => {
          if (res && res.body && res.body.linkUrl) {
            this.goGio(true, key);
            window.location.href = res.body.linkUrl;
          } else {
            this.goGio(false, key);
            window.location.href = `${origin}/health/search?keywords=${key}&city=${this.cid || "145"}`;
          }
        })
        .catch((err) => {
          this.goGio(false, key);
          window.location.href = `${origin}/health/search?keywords=${key}&city=${this.cid || "145"}`;
        });
    },

    goGio(isCi, key) {
      let pathName = window.location.pathname;
      let channelName = "优选生活";
      if (pathName.indexOf("home") > -1) {
        channelName = "优选生活";
      } else if (pathName.indexOf("book") > -1) {
        channelName = "图书";
      } else if (pathName.indexOf("birthday") > -1) {
        channelName = "生日汇";
      } else if (getQueryString("productTypes")) {
        channelName = getQueryString("productTypes");
      }

      // 埋点不处理翻译
      gioHandle(
        "DF_elementClick",
        {
          df_channle: channelName,
          df_searchKeyword: key || "未输入关键词",
          df_modulename: "搜索关键词",
          df_elementname: "搜索关键词",
          df_pagename: "搜索结果页",
          df_pageType: isCi ? "词链" : "",
        },
        "channelGio"
      );
    },

    getQuickSearchData(val) {
      this.apis.headerApi
        .getQuickSearch({ key: val, city: this.cid })
        .then((res) => {
          if (res.searchResponseDto && res.searchResponseDto.keyword) {
            this.keyword = res.searchResponseDto.keyword;
          } else {
            this.keyword = "";
          }

          if (res.searchResponseDto && res.searchResponseDto.products) {
            this.products = res.searchResponseDto.products;
          } else {
            this.products = [];
          }

          if (
            res.searchResponseDto &&
            res.searchResponseDto.suggestWords &&
            res.searchResponseDto.suggestWords.length
          ) {
            this.suggestWords = res.searchResponseDto.suggestWords || [];
          } else {
            this.suggestWords = [];
          }

          if (res.searchResponseDto && res.searchResponseDto.searches) {
            this.searches = res.searchResponseDto.searches;
          } else {
            this.searches = [];
          }
          this.cardInfos = res.searchResponseDto.cardInfos || [];
          this.count = res.searchResponseDto.count || 0;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.header-body {
  position: relative;
  .wrapper();
  &__container {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    background: #fff;
    z-index: 999;
    // box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.05);
  }
  &__vc {
    display: table-cell;
    vertical-align: middle;
    height: 130px;
  }
  &__logo {
    display: block;
    // width: 500px;
    > img {
      // width: 100%;
      height: 40px;
    }
  }

  &__search {
    display: inline-block;
    vertical-align: top;
    &_row {
      box-sizing: border-box;
      display: table-cell;
      vertical-align: middle;
      width: 500px;
      height: 46px;
      border: 1px solid #c9c9c9;
    }
  }
  &__city {
    display: block;
    text-align: center;
    border-right: 1px solid #cfcfcf;
    font-size: 16px;
    color: #0b49b7;
    &_cur {
      display: inline-block;
      vertical-align: top;
      max-width: 80px;
      margin-right: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: normal;
    }
    &_normal {
      position: relative;
      top: 1px;
      display: inline-block;
      vertical-align: middle;
      width: 0;
      height: 0;
      line-height: 0;
      font-size: 0;
      border-width: 5px;
      border-style: solid;
      border-color: #0b49b7 transparent transparent;
      transition: transform 0.3s;
    }
    &_active {
      transform: rotate(180deg) translateY(50%);
    }
  }
  &__input {
    box-sizing: border-box;
    width: 100%;
    height: 24px;
    padding: 2px 15px;
    font-size: 14px;
    background-color: #fff;
    background-image: none;
    border: none;
    outline: none;
    &::-webkit-input-placeholder {
      color: #999;
    }
    &::-moz-input-placeholder {
      color: #999;
    }
    &:-ms-input-placeholder {
      color: #999;
    }
  }
  &__btn {
    position: absolute;
    top: -1px;
    right: -1px;
    bottom: 0;
    width: 60px;
    line-height: 44px;
    height: 46px;
    text-align: center;
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: #1a4a9e;
      .header-body__glass {
        background-image: url("./imgs/glass_active.png");
      }
    }
  }
  &__glass {
    display: inline-block;
    vertical-align: middle;
    text-indent: -9999px;
    width: 24px;
    height: 24px;
    background: url("./imgs/glass_normal.png") no-repeat;
    background-size: cover;
  }
}
</style>
